import { Container } from 'inversify';
import { ProfileInterface, ProfileService } from './profile.service';

export const profileContainer = new Container();
profileContainer.bind<ProfileInterface>(ProfileService).toSelf().inSingletonScope();
